import { Button } from "react-bootstrap";
import React, { useEffect, useState } from "react";


interface cashRegisterData {
  addToPackages: any;
  prefix: string;
}
function CashRegister({addToPackages , prefix} : cashRegisterData) {
    const [myIndex, setMyIndex] = useState(0);

  const addPackage = () => {
    setMyIndex(myIndex + 1);
    addToPackages(prefix + myIndex);   
  };

  return (
    <>
      <div className="container">
        <h1>CAJA {prefix}</h1>

        <Button onClick={()=>addPackage()}>Agregar Siguiente Pedido para {prefix}</Button>
      </div>
    </>
  );
}

export default CashRegister;
